import {AxiosConfig} from '../../componentes/axiosConfig'

export class ObterPermissoesRecebimentoNotificacoes {
    constructor() {
        this._containerPermissoes     = document.getElementById('container-permissoes-recebimento-notificacoes');
        this._axios                   = (new AxiosConfig()).instanciaAxios();
        this._idSelectRastreavel      = $('#select2-popular-rastreaveis');
        this._idSelectCliente         = $('#cliente_id');
        this._idRastreavelSelecionado = $('#rastreavel-selecionado');
    }

    executar() {
        if (this._containerPermissoes && this._idSelectRastreavel.length !== 0) {
            this._idSelectRastreavel.on('select2:select', (evento) => {
                const clienteId = parseInt(this._idSelectCliente.val());
                const objetoResposta = evento.params.data;
                if (objetoResposta.id) {
                    this._obterPermissoes(clienteId, objetoResposta.id);
                }
            });
        }
    }

    /**
     * @private
     * @param {int} clienteId
     * @param {int} rastreavelId
     */
    _obterPermissoes (clienteId, rastreavelId) {
        try {
            const urlObterPermissoes = `notificacoes/permissoes/gerar-permissoes/${rastreavelId}`;
            this._axios.get(`${window.location.origin}/${urlObterPermissoes}?clienteId=${clienteId}`)
            .then((response) => {
                this._containerPermissoes.innerHTML = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        }
        catch (error) {
            console.log(error);
        }
    }
}
